var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
// imported only for typings
// these are passed to the component from index.ts
import { Carousel, CarouselItem } from "./components";
let FilterBlock = class FilterBlock extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const className = this.props.state.isEventView ? "rj-filter-block--side-panel" : "";
        const config = Object.assign(Object.assign({}, this.props.config), { iconSize: this.props.state.isEventView ? "24" : this.props.config.iconSize });
        return (React.createElement("div", { className: className },
            React.createElement(Carousel, { mobileScroll: this.props.state.mobileScroll, translate: this.props.state.CarouselTranslate }, this.props.state.Items.map((item, index) => React.createElement(CarouselItem, { key: `item-${index}`, item: item, config: config, handler: () => this.props.state.selectItem(item), isSelected: this.props.state.SelectedItemId === item.id })))));
    }
};
FilterBlock = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], FilterBlock);
export { FilterBlock };
//# sourceMappingURL=FilterBlock.js.map